module.exports = __webpack_public_path__ + "img/whoweare.7dcbd26c.png";